import { render, staticRenderFns } from "./color-picker-field.vue?vue&type=template&id=143efda0&scoped=true"
import script from "./color-picker-field.vue?vue&type=script&lang=js"
export * from "./color-picker-field.vue?vue&type=script&lang=js"
import style0 from "./color-picker-field.vue?vue&type=style&index=0&id=143efda0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143efda0",
  null
  
)

export default component.exports